export default __webpack_public_path__ + "static/media/visa.d0420273.png";